import script from "./concept.vue?vue&type=script&setup=true&lang=js"
export * from "./concept.vue?vue&type=script&setup=true&lang=js"

import "./concept.vue?vue&type=style&index=0&id=1d07a066&lang=less"
import "./concept.vue?vue&type=style&index=1&id=1d07a066&lang=less&scoped=true"
script.__scopeId = "data-v-1d07a066"

export default script